/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const o=Symbol("Accessor-beforeDestroy");export{o as beforeDestroySymbol};
